import { Tooltip } from "antd";
import classNames from "classnames";
import { DocumentState, DocumentStateType, KizMark, KizState, TypeDictionaries, СhequesKizStatus } from "../../@types/enumsGlobal";
import { Delete2Icon } from "../../libs/corporate/icons/outlined/action/MainCollection";
import { RightIcon } from "../../libs/corporate/icons/outlined/directions/ArrowsInCircleCollection";
import { KizBarcodeIcon } from "../../libs/corporate/icons/outlined/kiz/KizBarcodeCollection";
import { Circle, } from "../../libs/corporate/icons/outlined/suggested/CircleCollection";
import { DisketteIcon } from "../../libs/corporate/icons/panels/PanelCollection";
import styles from './styles/StatusIcon.module.scss'
import stylesType from './styles/TypeStatusIcon.module.scss'
import { RoundDone, RoundPlusMinus, SentIcon } from "../../libs/corporate/icons/outlined/other/MailCollection";
import { TooltipPlacement } from "antd/lib/tooltip";
import { applyConversionWithType } from "./conversion";

const tooltipProps = {
    placement: "top" as TooltipPlacement,
    autoAdjustOverflow: false as boolean,
    overlayStyle: { maxWidth: 300 } as React.CSSProperties,
    getPopupContainer: () => document.body as HTMLElement
};

export const returnStatusIcon = (status: DocumentStateType) => {
    switch (status) {
        case 'new': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.new}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.draft)} />
                    </div>
                </Tooltip>

            )
        }
        case 'draft': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.draft}>
                    <div className={styles.wrapper}>
                        <DisketteIcon className={classNames(styles.common, styles.draft)} />
                    </div>
                </Tooltip>

            )
        }
        case 'proc': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.proc} >
                    <div className={styles.wrapper}>
                        <RightIcon className={classNames(styles.common, styles.proc)} />
                    </div>
                </Tooltip>

            )
        }
        case 'done': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.done} >
                    <div className={styles.wrapper}>
                        <RoundDone className={classNames(styles.common, styles.proc)} />
                    </div>
                </Tooltip>

            )
        }
        case 'secured': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.secured} >
                    <div className={styles.wrapper}>
                        <RoundDone className={classNames(styles.common, styles.proc)} />
                    </div>
                </Tooltip>

            )
        }
        case 'mdlp': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.mdlp} >
                    <div className={styles.wrapper}>
                        <RoundDone className={classNames(styles.common, styles.proc)} />
                    </div>
                </Tooltip>

            )
        }
        case 'del': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.del}>
                    <div className={styles.wrapper}>
                        <Delete2Icon className={classNames(styles.common, styles.del,)} />
                    </div>
                </Tooltip>

            )
        }
        case 'cancel': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.cancel}>
                    <div className={styles.wrapper}>
                        <RoundPlusMinus className={classNames(styles.common, styles.del,)} />
                    </div>
                </Tooltip>

            )
        }
        case 'sent': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.sent}>
                    <div className={styles.wrapper}>
                        <SentIcon className={classNames(styles.common, styles.del,)} />
                    </div>
                </Tooltip>
            )
        }
        case 'Open': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.Open}>
                    <div className={styles.wrapper}>
                        <DisketteIcon className={classNames(styles.common, styles.del,)} />
                    </div>
                </Tooltip>

            )
        }
        case 'Closed': {
            return (
                <Tooltip {...tooltipProps} title={DocumentState.Closed}>
                    <div className={styles.wrapper}>
                        <RightIcon className={classNames(styles.common, styles.del,)} />
                    </div>
                </Tooltip>

            )
        }
    }
}
export const returnKizStatusIcon = (status) => {
    switch (status) {
        case 'Save': {
            return (
                <Tooltip {...tooltipProps} title={KizState.Save}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizSave)} />
                    </div>
                </Tooltip>

            )
        }
        case 'Proc': {
            return (
                <Tooltip {...tooltipProps} title={KizState.Proc}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizProc)} />
                    </div>
                </Tooltip>

            )
        }
        case 'Exit': {
            return (
                <Tooltip {...tooltipProps} title={KizState.Exit}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.exit)} />
                    </div>
                </Tooltip>

            )
        }
        default:
            return (
                <Tooltip {...tooltipProps} title={KizState.Error}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizExit)} />
                    </div>
                </Tooltip>

            )
    }
}

export const returnMarkingStatusIcon = (status) => {
    switch (status) {
        case 'noKizs': {
            return <>
                <Tooltip {...tooltipProps} title={KizMark.NoKiz}>
                    <div className={classNames(styles.field_Kiz_NoKiz)}> КИЗ </div>
                </Tooltip>

            </>
        }
        case 'allSave': {
            return <>
                <Tooltip {...tooltipProps} title={KizMark.AllSave}>
                    <div className={classNames(styles.field_Kiz_AllSave)}> КИЗ </div>
                </Tooltip>

            </>
        }
        case 'allSuccess': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.AllSuccess}>
                    <div className={classNames(styles.field_Kiz_AllSuccess)}> КИЗ </div>
                </Tooltip>

            )
        }
        case 'allFailed': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.AllFailed}>
                    <div className={classNames(styles.field_Kiz_AllFailed)}> КИЗ </div>
                </Tooltip>

            )
        }
        case 'partialSuccess': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.PartialSuccess}>
                    <div className={classNames(styles.field_Kiz_PartialSuccess)}> КИЗ </div>
                </Tooltip>

            )
        }
        /*case 'partialDisposed': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.PartialDisposed}>
                    <div className={classNames(styles.field_Kiz_PartialSuccess)}> ВЫБ </div>
                </Tooltip>

            )
        }*/
        default:
             return (
                <Tooltip {...tooltipProps} title={KizMark.AllFailed}>
                    <div className={classNames(styles.field_Kiz_AllFailed)}> КИЗ </div>
                </Tooltip>

            )
    }
}

export const returnDisposalStatusIcon = (status) => {
    status = applyConversionWithType('kizMarkDisposalState', status);
    switch(status) {
        case 'inProgressDisposal': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.InProgressDisposal}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.inProgressDisposal)} />
                    </div>
                </Tooltip>
            )
        }
        case 'allDisposed': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.AllDisposed}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.allKizDisposed)} />
                    </div>
                </Tooltip>
            )
        }
        case 'noneDisposed': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.NoneDisposed}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.noKiz)} />
                    </div>
                </Tooltip>
            )
        }
        case 'partialDisposed': {
            return (
                <Tooltip {...tooltipProps} title={KizMark.PartialDisposed}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.noKiz)} />
                    </div>
                </Tooltip>

            )
        }
        case 'noKizs': {
            return <>
                <Tooltip {...tooltipProps} title={""}>
                </Tooltip>
            </>
        }
    }
}

export const returnChequesKizStatusIcon = (status: number) => {
    switch (status) {
        case 0: {
            return (
                <Tooltip {...tooltipProps} title={СhequesKizStatus.RED}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizExit)} />
                    </div>
                </Tooltip>

            )
        }
        case 1: {
            return (
                <Tooltip {...tooltipProps} title={СhequesKizStatus.YELLOW}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizSave)} />
                    </div>
                </Tooltip>

            )
        }
        case 2: {
            return (
                <Tooltip {...tooltipProps} title={СhequesKizStatus.GREEN}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizProc)} />
                    </div>
                </Tooltip>

            )
        }
        case 5: {
            return (
                <Tooltip {...tooltipProps} title={СhequesKizStatus.ORANGE}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizInProcess)} />
                    </div>
                </Tooltip>

            )
        }
        case 4: {
            return (
                <Tooltip {...tooltipProps} title={СhequesKizStatus.BLUE}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizRequest)} />
                    </div>
                </Tooltip>
            )
        }
        default:
            return (
                <Tooltip {...tooltipProps} title={СhequesKizStatus.GRAY}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, styles.kizNoRequest)} />
                    </div>
                </Tooltip>

            )
    }
}

export const returnKizEditIcon = (isKiz: boolean, action: () => void) => {
    return (
        <>
            {
                isKiz ? <Tooltip {...tooltipProps} title='Редактировать КИЗ'>
                    <div className={styles.kizWrapper} onClick={(e) => {
                        e.stopPropagation()
                        action()
                    }}>
                        <KizBarcodeIcon className={styles.editKiz} />
                    </div>
                </Tooltip> : <></>
            }
        </>
    )
}

export const returnTypeIcon = (status) => {
    switch (status) {
        case 'stop': {
            return (
                <Tooltip {...tooltipProps} title={TypeDictionaries.Stop}>
                    <div className={stylesType.wrapper}>
                        <Circle className={classNames(stylesType.common, stylesType.stop)} />
                    </div>
                </Tooltip>

            )
        }
        case 'allow': {
            return (
                <Tooltip {...tooltipProps} title={TypeDictionaries.Allow}>
                    <div className={stylesType.wrapper}>
                        <Circle className={classNames(stylesType.common, stylesType.allow)} />
                    </div>
                </Tooltip>

            )
        }
        case 'block': {
            return (
                <Tooltip {...tooltipProps} title={TypeDictionaries.Block}>
                    <div className={stylesType.wrapper}>
                        <Circle className={classNames(stylesType.common, stylesType.block)} />
                    </div>
                </Tooltip>

            )
        }
        default:
            return (
                <Tooltip {...tooltipProps} title={TypeDictionaries.error}>
                    <div className={styles.wrapper}>
                        <Circle className={classNames(styles.common, stylesType.error)} />
                    </div>
                </Tooltip>

            )
    }
}